import { GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { API } from "aws-amplify";

import {
  UpdateAskPCOSUserMutation,
  UpdateAskPCOSUserMutationVariables,
} from "../../../../api/graphql/API";
import { updateAskPCOSUser } from "../../../../graphql/mutations";
import { AskPCOSUserType } from "../../../types";

const bookmarkArticle = async (
  userProfile: AskPCOSUserType,
  articleSlug: string
) => {
  if (!userProfile) return null;
  let bookmarkedArticlesList: (string | null)[] = [articleSlug];
  if (userProfile.bookmarked_articles) {
    bookmarkedArticlesList = userProfile.bookmarked_articles.filter(
      item => item !== articleSlug
    );
    if (
      bookmarkedArticlesList.length === userProfile.bookmarked_articles.length
    ) {
      bookmarkedArticlesList = [...bookmarkedArticlesList, articleSlug];
    }
  }
  const newUserProfile = (await API.graphql({
    query: updateAskPCOSUser,
    variables: {
      input: {
        id: userProfile.id,
        bookmarked_articles: bookmarkedArticlesList,
      },
    } as UpdateAskPCOSUserMutationVariables,
    authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
  })) as { data: UpdateAskPCOSUserMutation };
  return newUserProfile.data.updateAskPCOSUser;
};

export default bookmarkArticle;
